var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D0085955-4B72-45D1-AFF9-6D4D8150B564") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems/List/24",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.37482676,16.2002822 C1.61534585,16.2002822 1,16.826832 1,17.6001411 C1,18.3734503 1.61534585,19 2.37482676,19 C3.13569359,19 3.74965352,18.3734503 3.74965352,17.6001411 C3.74965352,16.826832 3.13569359,16.2002822 2.37482676,16.2002822 L2.37482676,16.2002822 Z M2.37482676,10.6008467 C1.61534585,10.6008467 1,11.2273964 1,12.0007056 C1,12.7740147 1.61534585,13.4005645 2.37482676,13.4005645 C3.13569359,13.4005645 3.74965352,12.7740147 3.74965352,12.0007056 C3.74965352,11.2273964 3.13569359,10.6008467 2.37482676,10.6008467 L2.37482676,10.6008467 Z M2.37482676,5 C1.61534585,5 1,5.62654974 1,6.39985889 C1,7.17316803 1.61534585,7.79971777 2.37482676,7.79971777 C3.13569359,7.79971777 3.74965352,7.17316803 3.74965352,6.39985889 C3.74965352,5.62654974 3.13569359,5 2.37482676,5 L2.37482676,5 Z M5.1258662,18.3000706 L23,18.3000706 L23,16.9002117 L5.1258662,16.9002117 L5.1258662,18.3000706 Z M5.1258662,12.700635 L23,12.700635 L23,11.3007761 L5.1258662,11.3007761 L5.1258662,12.700635 Z M5.1258662,7.09978833 L23,7.09978833 L23,5.69992944 L5.1258662,5.69992944 L5.1258662,7.09978833 Z",
    id: "List"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList24);
export default __webpack_public_path__ + "static/media/list_24.b86fb24fba718e0d344406bf58768b3d.svg";
export { ForwardRef as ReactComponent };